import axios from 'axios';
import store from '@/store/index.js';

const eventsRequest = axios.create({
  baseURL: "https://web.tnu.edu.tw/home_page/pages/",
  timeout: 10000,
  headers: { "Content-Type": "multipart/form-data" }
});

eventsRequest.interceptors.request.use(
  (config) => {
    // console.log('攔截請求');
    switch (config.url) {
      case "getCourseBySbj.php": {
        return config;
      }
      default: {
        store.commit('setIsLoading', true);
        return config
      }
    }
  },
  (err) => {
    console.log(err + '請求失敗')
    setTimeout(() => {
      store.commit('setIsLoading', false)
    }, 1000);
  }
);

eventsRequest.interceptors.response.use(
  (res) => {
    // console.log('攔截回應');
    setTimeout(() => {
      store.commit('setIsLoading', false)
    }, 1000);
    return res
  },
  (err) => {
    console.log(err + '回應失敗')
    setTimeout(() => {
      store.commit('setIsLoading', false)
    }, 1000);
  }
);


// post API

//取得首頁新聞
export const get_posts = (obj) => {
  return eventsRequest.post('getPosts.php', obj)
}
//取得首頁新聞總筆數
export const get_posts_count = (obj) => {
  return eventsRequest.post('getPostsCount.php', obj)
}
//取得單則首頁新聞
export const get_posts_by_id = (obj) => {
  return eventsRequest.post('getPostsById.php', obj)
}
//取得首頁公告
export const get_posts_news = (obj) => {
  return eventsRequest.post('getPostsNews.php', obj)
}
//取得首頁公告總筆數
export const get_posts_news_count = (obj) => {
  return eventsRequest.post('getPostsNewsCount.php', obj)
}
//取得單則首頁公告
export const get_posts_news_by_id = (obj) => {
  return eventsRequest.post('getPostsNewsById.php', obj)
}